import { formatMoney } from '@betterment/js-runtime';
import { numberRoundDownWithDecimals } from '@betterment/shared-components';
import { format } from 'date-fns';

import { ForecasterProjectionChart } from '../../../../shared/components/ForecasterProjectionChart';
import { ProjectionHighlight } from '../../../../shared/components/ProjectionHighlight';
import { Disclosures, PurposeEmergencyFund } from '../../../data';

type Props = {
  purpose: PurposeEmergencyFund;
  disclosures: Disclosures;
};

export const EmergencyFundProjection = ({ disclosures, purpose }: Props) => {
  const { emergencyFundTarget: target, emergencyFundProjection: projection } = purpose;
  const timeSeries = projection.balanceTimeSeries;
  if (!timeSeries) return null;

  const finalPoint = timeSeries[timeSeries.length - 1];

  return (
    <ForecasterProjectionChart targetAmount={target?.amount} disclosures={disclosures} timeSeries={timeSeries}>
      <ForecasterProjectionChart.Header>
        <ProjectionHighlight
          title={`Projected ${format(finalPoint.date, 'MMM yyyy')}`}
          value={formatMoney(finalPoint.expected)}
          subtitle={`${numberRoundDownWithDecimals(projection.monthsExpensesCovered, 1)} months expenses`}
        />
        {target && (
          <ProjectionHighlight
            title="Target balance"
            value={formatMoney(target.amount)}
            subtitle={`${numberRoundDownWithDecimals(target.monthsExpensesCovered, 1)} months expenses`}
          />
        )}
      </ForecasterProjectionChart.Header>
    </ForecasterProjectionChart>
  );
};
